export enum LevelOfEffort {
  'N/A',
  Minimal,
  Moderate,
  Maximum,
}

export type LevelOfEffortLabel = keyof typeof LevelOfEffort;
